/**
 *  Polyfills for Babel
 *  The polyfills will be either replaced or removed by babel depending on browserlist config
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'jquery-ui-dist/jquery-ui';
import 'bootstrap';
import './app/app';

import $ from 'jquery';
import fixWrapperHeight from './app/fixWrapperHeight';

$(document).ready(() => {
  $('.pending-load').show();

  window.addEventListener('storage', ({ key, newValue }) => {
    if (key === 'loggedOut' && newValue === 'true') {
      $('#logged-out-notification').show();
    } else if ((key === 'loggedOut' && newValue === null) || key === 'login') {
      window.location.reload();
    }
  });

  setTimeout(() => {
    fixWrapperHeight();
  }, 300);
});
